import { TWA } from "@/components/twa";

export const EmulateTwaPage = () => {
  const telegramUserId = 7200278743;

  return <TWA telegramUserId={telegramUserId} />;
};
